import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { Container, Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';

const useQuery = ()=>{
    return new URLSearchParams(useLocation().search);
};

export const LogOut = ()=>{
    const { t } = useTranslation();
    const query = useQuery();
    const [iframeLocation, setIframeLocation] = useState();
    const logoutId = query.get('logoutId');
    useEffect(() => {
        if(logoutId) {
            axios.get(`/api/auth/identity/account/v1/logout?logoutId=${logoutId}`, {
                headers: { 'credentials': 'include' }
            }
            ).then((response) => {
                if(response && response?.data) {
                    const data = response.data.r;
                    if(data?.signOutIFrameUrl)
                    {
                        setIframeLocation(data.signOutIFrameUrl);
                    }
                    if(data?.postLogoutRedirectUri)
                    {
                        window.location = data.postLogoutRedirectUri;
                    }
                }
            }).catch((getErr) =>{
                console.log(getErr);
            });
        }
    }, [logoutId]);

    return (
        <StyledContainer>
            <StyledIframe title='logout frame' src={iframeLocation}></StyledIframe>
            <Grid container item xs={12}>
                <TitleTypography>{t('successfullySignedOut')}</TitleTypography>
                <Typography>{t('beingRedirected')}</Typography>
            </Grid>
            <Grid container item xs={12}>
                <StyledSpinner/>
            </Grid>
        </StyledContainer>
    );

};

const StyledContainer = styled(Container)`
    margin-top: 40px;
    font: Roboto;
    font-style: normal;
    font-family: sans-serif;
`;

const TitleTypography = styled(Typography)`
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 15px;
`;

const StyledSpinner = styled(CircularProgress)`
    color: #888888;
    position: fixed;
    top: 30%;
    left: 44%;
`;

const StyledIframe = styled.iframe`
    position: absolute; 
    width:0; 
    height:0; 
    border:0;
`;